import styled from "styled-components";
import Navbar from "../../components/navbar/Navbar";
import NeedAssistanceSection from "../../components/section/contact/NeedAssistanceSection";
import Footer from "../../components/section/footer/Footer";
import MenuSpacer from "../../components/spacer/MenuSpacer";
import RecommendationSection from "../product/componets/RecommendationSection";
import DashboardTabs from "./components/DashboardTabs";

const Wrapper = styled.div``;

function DashboardPage() {
  return (
    <Wrapper>
      <Navbar />
      <MenuSpacer />
      <DashboardTabs />
      {/* <RecommendationSection /> */}
      <NeedAssistanceSection />
      <Footer />
    </Wrapper>
  );
}

export default DashboardPage;
